import type { ReactNode } from "react";
import { Button as AriaButton } from "react-aria-components";
import { cx } from "../cx.js";
import styles from "./Tile.module.css";

/** Große Auswahlkachel (Sprache, Mitarbeitende, Startaktionen) – Touch-Ziel ≥ 72 px */
export function Tile({
  title,
  subtitle,
  icon,
  onPress,
  selected,
  lang,
  dir,
  className,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  icon?: ReactNode;
  onPress: () => void;
  selected?: boolean;
  lang?: string;
  dir?: "ltr" | "rtl";
  className?: string;
}) {
  return (
    <AriaButton
      className={cx(styles.tile, selected && styles.selected, className)}
      onPress={onPress}
      aria-pressed={selected}
    >
      {icon ? (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <span className={styles.text}>
        <span className={styles.title} lang={lang} dir={dir}>
          {title}
        </span>
        {subtitle ? <span className={styles.subtitle}>{subtitle}</span> : null}
      </span>
    </AriaButton>
  );
}

export function TileGrid({
  children,
  label,
  min = 200,
}: {
  children: ReactNode;
  label: string;
  min?: 160 | 200 | 260;
}) {
  return (
    <div role="group" aria-label={label} className={cx(styles.grid, styles[`min${min}`])}>
      {children}
    </div>
  );
}
